import React, { useContext, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import {
  doc,
  getFirestore,
  setDoc,
  Timestamp,
  updateDoc,
} from "firebase/firestore";
import { useDocument } from "react-firebase-hooks/firestore";
import { SpeedoMeter } from "../../components";
import { firebaseApp } from "../../config/firebase";

import { SpeechBubble } from "../../components";
import Container from "@mui/material/Container";

import { colorPalettes } from "../../mock_data/data";
import { AuthContext } from "../../context/AuthContext";

const db = getFirestore(firebaseApp);

export const SpeedoMeterPage = () => {
  const { auth } = useContext(AuthContext);

  const [searchParams] = useSearchParams();
  const [colors, setColors] = React.useState(colorPalettes[0].colors);
  const [intervalCount, setIntervalCount] = React.useState(0);

  const [data, loading, error] = useDocument(doc(db, `users/${auth.user.id}`), {
    snapshotListenOptions: { includeMetadataChanges: true },
  });

  const getRandomInt = (max) => {
    return Math.floor(Math.random() * max);
  };

  const getFormattedData = (i) => {
    const docData = auth.user.data[i];
    docData.Accuracy = parseFloat(docData.Accuracy);
    docData.AvgDiffClass = parseFloat(docData.AvgDiffClass);
    docData.AvgDiffScore = parseFloat(docData.AvgDiffScore);
    docData.DiffScore = parseFloat(docData.DiffScore);
    docData.date = Timestamp.fromDate(new Date());
    return docData;
  };
  const updateScore = async () => {
    if (data) {
      const docRef = doc(db, "users", auth.user.id);
      const payload = getFormattedData(getRandomInt(auth.user?.data?.length));
      updateDoc(docRef, payload);
    }
  };

  const addUserData = async () => {
    try {
      let docData = getFormattedData(0);
      await setDoc(doc(db, "users", auth?.user?.id), docData);
    } catch (err) {
      console.log("Error while setting value", err);
    }
  };

  useEffect(() => {
    if (data && !data.data()) {
      addUserData();
    }
  }, [data]);

  useEffect(() => {
    const interval = setInterval(() => {
      setIntervalCount(intervalCount + 1);
      updateScore();
    }, 4000);

    // clear on component unmount
    return () => {
      clearInterval(interval);
    };
  }, [intervalCount]);

  const updateColors = (type) => {
    if (!type) return;
    let index = colorPalettes.findIndex(
      (color) => color.speedometerType == type
    );
    if (index !== -1) setColors(colorPalettes[index].colors);
  };

  const getHeading = () => {
    const speedometerType = searchParams.get("type");
    if (speedometerType === "1") {
      return "Accuracy Meter";
    } else if (speedometerType === "2") {
      return "Difficulty vs Accuracy";
    } else if (speedometerType === "3") {
      return "Performance Meter";
    }
    return "Accuracy Meter";
  };

  useEffect(() => {
    updateColors(searchParams.get("type"));
  }, []);

  if (error) {
    return (
      <div>
        <h1>Database Error</h1>
      </div>
    );
  }

  return (
    <Container>
      <h1>{`${getHeading()}`}</h1>
      <Container
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div>
          <SpeedoMeter
            fetching={loading}
            data={data && data.data() ? data.data() : null}
            colorPalette={colors}
            speedometerType={searchParams.get("type")}
          />
        </div>
        {!loading && searchParams.get("type") === "3" ? (
          <SpeechBubble
            value={data && data.data() ? data.data().Accuracy : 0}
          />
        ) : null}
      </Container>
    </Container>
  );
};
